var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"support-box"},[(_vm.support_information == 1)?_c('p',{staticClass:"support",style:({color: _vm.themecolors}),on:{"click":_vm.skip}},[_vm._v(" 技术支持："+_vm._s(_vm.technical_support)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }